import React from 'react';
import { Link } from 'react-router-dom';
import DelayRender from './DelayRender';
import blackjackImage from '../assets/blackjack.webp';
import spinWheelImage from '../assets/spin.webp';
import slotsImage from '../assets/slots.webp';
import plinkoImage from '../assets/plinko.webp';
import rouletteImage from '../assets/roulette.png';
import raffleImage from '../assets/raffle.webp';
import './Casino.css';

const Casino = () => {
  return (
    <div className="page">
      <div className="page-container">
        <div className="casino-header">
          <h3 className="casino-header">Casino</h3>
        </div>
        <div className="games-list">
          <Link to="/portal/raffle" className="game-panel">
            <img src={raffleImage} alt="Raffle" className="game-icon" />
            <div className="game-info">
              <h3>Raffle</h3>
              <p>Buy tickets and win big prizes!</p>
            </div>
          </Link>
          <Link to="/portal/blackjack" className="game-panel">
            <img src={blackjackImage} alt="Blackjack" className="game-icon" />
            <div className="game-info">
              <h3>Blackjack</h3>
              <p>Try your luck at Blackjack!</p>
            </div>
          </Link>
          <Link to="/portal/spin" className="game-panel">
            <img src={spinWheelImage} alt="Spin the Wheel" className="game-icon" />
            <div className="game-info">
              <h3>Spin the Wheel</h3>
              <p>Play Spin the Wheel!</p>
            </div>
          </Link>
          <Link to="/portal/slots" className="game-panel">
            <img src={slotsImage} alt="Slots" className="game-icon" />
            <div className="game-info">
              <h3>Classic Slots</h3>
              <p>Enjoy the classic slots experience!</p>
            </div>
          </Link>
          <Link to="/portal/roulette" className="game-panel">
            <img src={rouletteImage} alt="Roulette" className="game-icon" />
            <div className="game-info">
              <h3>Roulette</h3>
              <p>Place your bets and win big!</p>
            </div>
          </Link>
          <Link to="/portal/plinko" className="game-panel">
            <img src={plinkoImage} alt="Plinko" className="game-icon" />
            <div className="game-info">
              <h3>Plinko</h3>
              <p>Drop the ball and win prizes!</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DelayRender(Casino, 200);
